import { useTranslation } from '@/composables';
import { type Contact, type Quote } from '@/generated/graphql';

export const useQuote = () => {
	const { t } = useTranslation();

	const getDisplayName = (
		quote: Pick<Quote, 'number' | 'quoteName'> & {
			mainContact?: Pick<Contact, 'name'> | null;
		}
	) => {
		if (!quote.quoteName) {
			if (quote.mainContact) {
				return `${quote.number} ${quote.mainContact.name} ${t(
					'quote'
				).toLocaleLowerCase()}`;
			}

			return `${quote.number} ${t('quote').toLocaleLowerCase()}`;
		}

		return `${quote.number} ${quote.quoteName}`;
	};

	return {
		getDisplayName,
	};
};
